import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface NoResultsProps {
  closeSearch: () => void
}

function NoResults({ closeSearch }: NoResultsProps) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const handleCloseSearch = () => {
    closeSearch();
    dispatch.events.setSearch('');
  };

  return (
    <div className="sports-betting__results">
      <span className="sports-betting__no-results">{ t('sports.noResults') }</span>
      <span
        className="sports-betting__close-search"
        onClick={ handleCloseSearch }
      >
        { t('sports.closeSearch') }
      </span>
    </div>
  );
}

export default NoResults;
